import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { toast } from "react-toastify";
import { openSubscriptionModal } from "./subscriptionModalSlice";
import { openUpgradeSubscriptionModal } from "./upgradeSubModalSlice";


const rawBaseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_BASEURL,
  prepareHeaders: (headers, { getState }) => {
    // By default, if we have a token in the store, let's use that for authenticated requests
    const token = localStorage.getItem("token");
    if (token) {
      headers.set("authorization", `Bearer ${token}`);
    }
    return headers;
  },
});

export const baseQuery = async (args, api, extraOptions) => {
  const result = await rawBaseQuery(args, api, extraOptions);

  if (
  result.error &&
  result.error.status === 402 &&
  typeof result.error.data === "object" &&
  result.error.data !== null &&
  "message" in result.error.data
) {
  const message = (result.error.data as { message?: string }).message;
  if (message === "Subscription Required") {
    toast.error("Subscription is required to access this feature.");
    api.dispatch(openSubscriptionModal());
    console.log("***Subscription Required");
  } else if (message === "Subscription Upgrade Required") {
    toast.error("Subscription upgrade is required to access this feature.");
    api.dispatch(openUpgradeSubscriptionModal());
    console.log("Subscription Upgrade Required");
  }
}
  if (result.error) {
    console.log('BaseQuery error:', result.error);
  }

  return result;
};

// export const NoTokenbaseQuery = fetchBaseQuery({
//   baseUrl: process.env.REACT_APP_BASEURL,
//   prepareHeaders: (headers, { getState }) => {
//     // By default, if we have a token in the store, let's use that for authenticated requests
//     const token =
//       "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjA1NjY0Y2VjLWZkZDAtNDc1ZC04NGM2LTQzZDIwNzFhMTQ0ZCIsInJvbGUiOjIsImhvc3BpdGFsSWQiOiJkZWZhdWx0IiwiaWF0IjoxNjQxMDM1ODE1LCJleHAiOjE2NDEwODE1OTh9.jiteLFdj_lbbUmJIc7FsKbIb26eoUZoN3ac1R6mrVK8";
//     if (token) {
//       headers.set("authorization", `Bearer ${token}`);
//     }
//     return headers;
//   },
// });
